<template>
  <!-- 年度规划申请 | 年度规划申请详情 -->
  <div class="annualPlanApplication">
    <!-- 头部 -->
    <commonHeader>
      <template v-if="isReadonly" #buttons>
        <!-- 召回 -->
        <el-button v-if="btnShowControl.showRecall" plain @click="recallBtn">召回修改</el-button>
        <!-- 驳回 -->
        <el-button v-if="btnShowControl.showReject" plain @click="agreeRejectBtn($t('btn.Rejected'))">驳回</el-button>
        <!-- 同意 -->
        <el-button v-if="btnShowControl.showAgree" plain @click="agreeRejectBtn($t('btn.Agree'))">同意</el-button>
      </template>
    </commonHeader>
    <!-- 基础信息 -->
    <BasicInformation ref="basicInformation" :is-loading="isLoading" :is-readonly="isReadonly" :edit-echo-data="editEchoData" @typeChange="handleTypeChange" />
    <!-- 年度规划指标 -->
    <annualPlanTarget ref="annualPlanTarget" :is-loading="isLoading" :is-readonly="isReadonly" :edit-echo-data="editEchoData" :type-val="typeVal" />
    <!-- 操作按钮 -->
    <div v-if="(!isReadonly && !isLoading) || isCompletedEdit === 2" class="btn-list">
      <el-button plain @click="backBtn">返回</el-button>
      <el-button v-if="id && isCompletedEdit !== 2" type="primary" @click="discardBtn">废弃</el-button>
      <el-button type="primary" :loading="isSubmitting" @click="submitBtn">提交</el-button>
    </div>
    <!-- 审批弹窗 -->
    <approveDialog ref="approveDialog" @approveSubHandle="approveSubHandle" />
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import BasicInformation from './components/basicInformation.vue';
import annualPlanTarget from './components/annualPlanTarget.vue';
import approveDialog from '../components/approveDialog.vue';
import { annualApplicationApi } from '../service';
import { isNotEmpty } from '@/utils/utils';
import { QUARTER_PERIODS } from '@/utils/constants';
export default {
  components: {
    commonHeader,
    BasicInformation,
    annualPlanTarget,
    approveDialog
  },
  data () {
    return {
      isDetails: false, // 当前页面是否是详情
      typeVal: '',
      id: '',
      editEchoData: {}, // 编辑回显数据
      isRecall: false, // 是否是召回修改
      isLoading: true, // 是否正在加载
      isSubmitting: false, // 是否正在提交
      isCompletedEdit: 1 // 状态是否是已完成编辑
    };
  },
  computed: {
    // 按钮显示控制
    btnShowControl () {
      const userInfo = this.$store.state.userInfo;
      if (!isNotEmpty(this.editEchoData)) {
        return {
          showRecall: false,
          showAgree: false,
          showReject: false,
          showSubmit: true
        };
      }
      const { status, submitUserName, allowApprove } = this.editEchoData;
      // 申请人是否是当前用户
      const isOperate = submitUserName === userInfo.sysUser.userName;
      const btns = {
        showRecall: false, // 召回
        showAgree: false, // 同意
        showReject: false, // 驳回
        showSubmit: false // 提交
      };
      // 1-审批中 2-已完成 3-驳回 4-召回 5-废弃 6-变更审批中 7-变更驳回 8-变更召回
      switch (status) {
        case 1:
        case 6:
          // 申请人是当前用户，才能召回
          btns.showRecall = isOperate;
          btns.showAgree = allowApprove;
          btns.showReject = allowApprove;
          break;
        case 3:
        case 7:
          // 申请人是当前用户，才能提交
          btns.showSubmit = isOperate;
          break;
        case 4:
          // 申请人是当前用户，才能提交
          btns.showSubmit = isOperate;
          break;
        case 5:
          break;
        default:
          break;
      }
      return btns;
    },
    isReadonly () {
      // 回显数据不存在，说明是新建，非只读
      if (!isNotEmpty(this.editEchoData)) {
        return false;
      }
      // 详情页，或非申请人，或已废弃，或已驳回，或已召回，都为只读
      return this.isDetails ? true : !this.btnShowControl.showSubmit;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    // 初始化方法
    init () {
      this.id = this.$route.query.id;
      if (this.$route.path === '/annualPlanDetails') {
        this.$refs.basicInformation.init();
      }
      if (this.id) {
        this.getAnnualPlanDetails();
      } else {
        this.isLoading = false;
      }
      if (this.$route.query.isCompletedEdit) {
        this.isCompletedEdit = this.$route.query.isCompletedEdit * 1;
      }
      this.isDetails = this.$route.path === '/annualPlanDetails' || (this.id && this.isCompletedEdit === 2); // 详情页或有id均为详情态
    },
    // 获取年度规划详情
    getAnnualPlanDetails () {
      this.isLoading = true;
      const params = {
        annualPlanId: this.id
      };
      annualApplicationApi.annualPlanDetail(params).then(res => {
        this.isLoading = false;
        if (res.status === '200') {
          const data = JSON.parse(JSON.stringify(res.data));
          this.editEchoData = data;
        }
      });
    },
    handleTypeChange (val) {
      this.typeVal = val;
    },
    backBtn () {
      this.$router.push({
        path: '/annualMarketingPlan'
      });
    },
    // 废弃按钮
    discardBtn () {
      this.$confirm('确定废弃该年度规划?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          annualPlanId: this.id
        };
        annualApplicationApi.annualPlanAbandon(params).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/annualMarketingPlan');
          }
        });
      }).catch(() => {});
    },
    // 提交按钮
    submitBtn () {
      this.$refs.basicInformation.validateHandler().then(valid => {
        if (valid) {
          // 年度规划基础信息
          const basicParams = JSON.parse(JSON.stringify(this.$refs.basicInformation.formData));
          delete basicParams.submitUser; // 删除冗余字段
          this.$refs.annualPlanTarget.validateHandler().then(valid => {
            if (valid) {
              this.isSubmitting = true;
              // 年度规划指标信息
              const annualParams = this.$refs.annualPlanTarget.getAnnualParamsValue();
              // 构造提交入参
              let params = {
                ...basicParams, // 年度规划基础信息
                ...annualParams // 年度规划指标信息
              };
              // 判断提交&编辑接口
              let requestUrl = this.id ? annualApplicationApi.annualPlanEdit : annualApplicationApi.annualPlanCreate;
              // 编辑、召回提交时传id
              if (this.id) {
                params.id = this.id;
              }
              // 审批完成后修改数据结构重组
              if (this.$route.query.isCompletedEdit === '2') {
                requestUrl = annualApplicationApi.annualPlanChange;
                const quarterEditable = annualParams.quarterEditable;
                const quarterList = [];
                const quarters = [];
                QUARTER_PERIODS.forEach(item => {
                  if (quarterEditable[item.key]) {
                    quarterList.push(item);
                  }
                });
                if (isNotEmpty(quarterList)) {
                  quarterList.forEach(period => {
                    let data = annualParams[period.key + 'Target'];
                    data.quarter = period.label;
                    quarters.push(data);
                  });
                }
                params = {
                  annualPlanId: this.id,
                  quarters
                };
              }
              console.log(params, 'params');
              requestUrl(params).then(res => {
                this.isSubmitting = false;
                if (res.status === '200') {
                  this.$message.success('提交成功');
                  this.$router.replace('/annualMarketingPlan');
                }
              }).catch(() => {
                this.isSubmitting = false;
              });
            }
          });
        }
      });
    },
    // 同意 | 拒绝按钮
    agreeRejectBtn (val) {
      this.$refs.approveDialog.init({
        type: val,
        visible: true
      });
    },
    // 审批提交
    approveSubHandle (parameter) {
      const { reason, type } = parameter;
      let requestUrl = '';
      if (type === '同意') {
        requestUrl = annualApplicationApi.annualPlanApprove;
      } else if (type === '驳回') {
        requestUrl = annualApplicationApi.annualPlanReject;
      }
      requestUrl({
        comment: reason,
        annualPlanId: this.id
      }).then(res => {
        if (res.status === '200') {
          this.$message.success(this.$t('general.OperSucc'));
          this.init();
        }
      });
    },
    // 召回按钮
    recallBtn () {
      this.$confirm('确定召回修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          annualPlanId: this.id
        };
        annualApplicationApi.annualPlanRecall(params).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.$router.push('/annualMarketingPlan');
          }
        });
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
.btn-list{
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
